"use client"

import { createContext, useCallback, useContext } from "react"
import type { SpotlightRequest } from "@/components/GlobalSearchDialog"

type TopBarSlotName = "back" | "left" | "leftMeta" | "right" | "controls"

type SlotClaims = Record<TopBarSlotName, number>

export interface ConversationRequest {
    question?: string
    threadId?: string
}

export interface TopBarContextValue {
    slots: Record<TopBarSlotName, HTMLElement | null>
    registerSlot: (name: TopBarSlotName, el: HTMLElement | null) => void
    claimSlot: (name: TopBarSlotName) => () => void
    claims: SlotClaims
    openSearch: () => void
    openSpotlight: (request: SpotlightRequest) => void
    isSpotlightOpen: boolean
    isSpotlightSearching: boolean
    setWilsonSubject: (subject: string) => void
    wilsonSubject: string
    setScopeDocumentType: (documentType: string) => void
    scopeSubject: string
    scopeDocumentType: string
    setIslandWidth: (width: number) => void
    openConversation: (request: ConversationRequest) => void
    isAsking: boolean
    hasAskRequest: boolean
    askId: number
    askingQuestion: string
    askingSubject: string | null
    startAsking: StartAsking | null
    stopAsking: (askId: number) => void
}

export interface AskOptions {
    subject?: string
}

export type StartAsking = (question?: string, options?: AskOptions) => void

export const TopBarContext = createContext<TopBarContextValue | null>(null)

export function useOpenChatThread(): (threadId: string) => void {
    const ctx = useContext(TopBarContext)
    const openConversation = ctx?.openConversation
    return useCallback(
        (threadId: string) => openConversation?.({ threadId }),
        [openConversation]
    )
}

export function useQuickAsk(): StartAsking | null {
    return useContext(TopBarContext)?.startAsking ?? null
}
